import { NullQ } from "@pdfking/structs"
import type { Atom } from "@pdfking/tfunc"

import type { Layout, LayoutLeaf } from "../types/layout"
import { PageLeaf } from "./PageLeaf"

/** Every page of `layout`, in tree order, without laying it out — the same
 * paths {@link LayoutPages} gives them. */
export function* LayoutLeaves<D>(layout: Layout<D>, prefix: Atom[] = []): Generator<LayoutLeaf<D>> {
  if (layout.enum === "page") {
    yield PageLeaf(layout, prefix)
    return
  }
  const inner = NullQ(layout.page_prefix) ? prefix : [...prefix, layout.page_prefix]
  for (const child of layout.layouts ?? []) yield* LayoutLeaves(child, inner)
}
